import i18n from "@/i18n";
export const menuItems = [
    {
        id: 3,
        isLayout: true
    },
    {
        id: 4,
        label: "CONSULTAS RENT A CAR",
        isTitle: true
    },
    {
        id: 5,
        label: "Convenios",
        icon: "bx-list-ul",
        link: "/convenios"
    },
    {
        id: 6,
        label: "lease.name",
        icon: "bx-calendar",
        link: "/arriendos"
    },
    // {
    //     id: 7,
    //     label: "Estados de pago",
    //     icon: "bx-calendar",
    //     link: "/estados-pago"
    // },
    {
        id: 8,
        label: "Reporte de TAG Interurbano",
        icon: "bxs-report",
        link: "/tagReport"
    },
    {
        id: 9,
        label: "Monitoreo GPS",
        icon: "bx-map",
        link: "/monitoreoGPS"
    },
    {
        id: 10,
        label: "Órdenes de taller",
        icon: "bx-brush",
        link: "/orden-taller"
    },
    {
        id: 11,
        label: "Infracciones de tránsito",
        icon: "bx-barcode",
        link: "/infraccionesRAC"
    },
    {
        id: 12,
        label: "Siniestros",
        icon: "bxs-ambulance",
        link: "/siniestros"
    },
    {
        id: 13,
        label: "Línea de Crédito",
        icon: "bx-credit-card",
        link: i18n.t('credits.path')+i18n.t('credits.creditsGranted.path')
    },
    {
        id: 14,
        label: "Red Points",
        icon: "bx-heart",
        link: "/red-points"
    },
    {
        id: 15,
        label: "Gastos reembolsables",
        icon: "bx-money",
        link: "/gastos-reembolsablesRAC"
    },
    {
        id: 16,
        label: "Cobros adicionales",
        icon: "bxs-receipt",
        link: "/additionals-charges"
    },
    {
        id: 17,
        label: "CONSULTAS LEASING OPERATIVO",
        isTitle: true
    },
    {
        id: 18,
        label: "Dashboard",
        icon: "bxs-dashboard",
        link: "/dashboardLOP"
    },
    {
        id: 19,
        label: "Arriendos",
        icon: "bx-calendar",
        link: "/arriendos-lop"
    },
    {
        id: 20,
        label: "Estados de pago",
        icon: "bx-calendar",
        link: "/"
    },
    {
        id: 21,
        label: "Detalle de flota",
        icon: "bx-car",
        link: "/detalle-flota"
    },
    {
        id: 22,
        label: "Reporte de TAG",
        icon: "bxs-report",
        link: "/tagReportLOP"
    },
    {
        id: 23,
        label: "Monitoreo GPS",
        icon: "bx-map",
        link: "/monitoreoGPS"
    },
    {
        id: 24,
        label: "Reporte de taller",
        icon: "bx-brush",
        link: "/reporte-taller"
    },
    {
        id: 25,
        label: "Infracciones de tránsito",
        icon: "bx-barcode",
        link: "/infraccionesLOP"
    },
    {
        id: 26,
        label: "Siniestros",
        icon: "bxs-ambulance",
        link: "/siniestros-lop"
    },
    {
        id: 27,
        label: "Unidades nuevas en preparación",
        icon: "bx-radio-circle-marked",
        link: "/unidades-nuevas"
    },
    {
        id: 28,
        label: "Gastos Reembolsables",
        icon: "bx-money",
        link: "/gastos-reembolsables"
    }
];
